import styled from 'styled-components'
import { Color, spacing, themeColor, transitions, Typography } from '~theme'
import { Animate, Animatable } from '~components/Animations'

export const Container = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: ${spacing()};
  height: 100%;
`

export const Content = styled.div<Animatable>`
  ${Animate.fade};
  visibility: ${({ isShown }) => !isShown && 'hidden'};
  height: 100%;

  transition: none;
  ${({ isShown }) => isShown && transitions(['opacity', 'visibility'], 1)}
`

export const LoadingContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const Placeholder = styled.div`
  margin-top: ${spacing(0.5)};
  color: ${themeColor(Color.primary)};
  ${Typography.labelLarge};
  ${Typography.textSemiStrong};
`
